module.exports = __webpack_public_path__ + "static/media/LeftAlignBlue.9dfddcf6.svg";